module.exports = __webpack_public_path__ + "img/banner.6d87505.png";